TripItemTaxiService.SERVICE_NAME = 'tripItemTaxiService';

export default function TripItemTaxiService() {
    Object.assign(this, {
        getFromToRoute,
        getDepartureDate,
        getFirstTaxi,
        getLastTaxi,
    });

    function getFromToRoute(recommendation) {
        const firstTaxi = getFirstTaxi(recommendation);
        const lastTaxi = getLastTaxi(recommendation);

        return `${firstTaxi.PickupLocation} &rarr; ${lastTaxi.DestinationLocation}`;
    }

    function getFirstTaxi(recommendation) {
        return recommendation
            && recommendation.TaxiInfos
            && recommendation.TaxiInfos[0];
    }

    function getLastTaxi(recommendation) {
        const count = recommendation && recommendation.TaxiInfos && recommendation.TaxiInfos.length;
        return count && recommendation.TaxiInfos[count - 1];
    }

    function getDepartureDate(recommendation) {
        return recommendation
            && recommendation.TaxiInfos
            && recommendation.TaxiInfos[0]
            && recommendation.TaxiInfos[0].DepartureDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/trip/trip-item-taxi/trip-item-taxi-service.js